module.exports = __webpack_public_path__ + "static/media/gif_Tipeee_step_2.5440025c.gif";